import { Action } from 'redux';
import { Map, OrderedMap } from 'immutable';

import {
    GET_EVENT_REQUEST,
    GET_EVENT_RESPONSE,
    GET_EVENT_ERROR,

    GET_PLACE_REQUEST,
    GET_PLACE_RESPONSE,
    GET_PLACE_ERROR,

    GET_EVENTS_REQUEST,
    GET_EVENTS_RESPONSE,
    GET_EVENTS_ERROR,

    SET_INPUT_VALUE,
} from '../../actions/Afisha/events';
import {
    SET_CITY,

    GET_CITIES_REQUEST,
    GET_CITIES_RESPONSE,
    GET_CITIES_ERROR,

    SET_CITY_VALUE,

    GET_CITY_REQUEST,
    GET_CITY_RESPONSE,
    GET_CITY_ERROR
} from '../../actions/Afisha/cities';

import { Event } from '../../models/Afisha/Event';
import { City } from '../../models/Afisha/City';
import { Place } from '../../models/Afisha/Place';

export interface EventsAfishaState {
    inputValue: string;

    events: Map<string, OrderedMap<number, Event>>;
    loadingEvents: boolean;
    errorEvents: any;

    city: City;
    loadingCities: boolean;
    loadingCity: boolean;
    cities: OrderedMap<number, City>;
    errorCities: any;
    errorCity: any;
    cityValue: string;

    event: Event;
    place: Place;
}

const initialState: EventsAfishaState = {
    inputValue: '',

    events: Map<string, OrderedMap<number, Event>>(),
    loadingEvents: false,
    errorEvents: null,

    city: {} as City,
    loadingCities: false,
    loadingCity: false,
    cities: OrderedMap<number, City>(),
    errorCities: null,
    errorCity: null,
    cityValue: '',

    event: {} as Event,
    place: {} as Place,
};

export function eventsAfisha(state: EventsAfishaState = initialState, action: Action) {
    switch (action.type) {
        case GET_EVENTS_REQUEST: {
            return {
                ...state,
                loadingEvents: true,
                errorEvents: initialState.errorEvents,
                events: initialState.events
            };
        }
        case GET_EVENTS_RESPONSE: {
            const events = (action as any).response;
            return {
                ...state,
                events,
                loadingEvents: false
            };
        }
        case GET_EVENTS_ERROR: {
            const errorEvents = (action as any).error;
            return {
                ...state,
                loadingEvents: false,
                errorEvents
            };
        }

        case GET_EVENT_REQUEST: {
            return {
                ...state,
                loadingEvents: true,
                errorEvents: initialState.errorEvents,
                event: initialState.event
            };
        }
        case GET_EVENT_RESPONSE: {
            const event = (action as any).response.result;
            return {
                ...state,
                event,
                loadingEvents: false
            };
        }
        case GET_EVENT_ERROR: {
            const errorEvents = (action as any).error;
            return {
                ...state,
                loadingEvents: false,
                errorEvents
            };
        }
        case GET_PLACE_REQUEST: {
            return {
                ...state,
                loadingEvents: true,
                errorEvents: initialState.errorEvents,
                place: initialState.place
            };
        }
        case GET_PLACE_RESPONSE: {
            const place = (action as any).response.result;
            return {
                ...state,
                place,
                loadingEvents: false
            };
        }
        case GET_PLACE_ERROR: {
            const errorEvents = (action as any).error;
            return {
                ...state,
                loadingEvents: false,
                errorEvents
            };
        }
        case SET_INPUT_VALUE: {
            const inputValue = (action as any).newValue;
            if (inputValue.length === 0 && inputValue.trim().length === 0) {
                return {
                    ...state,
                    events: initialState.events,
                    inputValue
                };
            }
            return {
                ...state,
                inputValue
            };
        }

        case SET_CITY: {
            const city = (action as any).city;
            return {
                ...state,
                city,
                events: initialState.events,
                inputValue: initialState.inputValue
            };
        }

        case GET_CITIES_REQUEST: {
            return {
                ...state,
                loadingCities: true,
                errorCities: initialState.errorCities
            };
        }
        case GET_CITIES_RESPONSE: {
            const result = (action as any).response.result as Array<City>;
            const cities = result.reduce((prev, cur) => {
                prev = prev.set(cur.id, cur);
                return prev;
            }, initialState.cities);
            return {
                ...state,
                loadingCities: false,
                cities
            };
        }
        case GET_CITIES_ERROR: {
            const errorCities = (action as any).error;
            return {
                ...state,
                errorCities,
                loadingCities: false
            };
        }

        case SET_CITY_VALUE: {
            const cityValue = (action as any).newValue;
            return {
                ...state,
                cityValue
            };
        }

        case GET_CITY_REQUEST: {
            return {
                ...state,
                loadingCity: true,
                city: initialState.city,
                errorCity: initialState.errorCity
            };
        }
        case GET_CITY_RESPONSE: {
            const city = (action as any).response.result as City;
            return {
                ...state,
                loadingCity: false,
                city,
                errorCity: null
            };
        }
        case GET_CITY_ERROR: {
            const errorCity = (action as any).error;
            return {
                ...state,
                errorCity,
                loadingCity: false
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Afisha/events.ts